import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const getCollection = async (collectionName) => {
  return (await getDocs(collection(db, collectionName))).docs.map(elem => elem.data());
  
};
